import * as React from "react";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header.tsx";
import MainGrid from "./components/MainGrid.tsx";
import fpTheme from "../../theme/fpTheme.ts";

const Dashboard = () => {
  return (
    <ThemeProvider theme={fpTheme}>
      <CssBaseline />
      {/* Grid container with an inner Stack for vertical layout */}
      <Grid
        container
        direction="column"
        spacing={2}
        sx={{
          m: 0,
          flexGrow: 1,
          alignItems: "center",
          height: "100vh", // Fixed height to viewport (moved from removed Box)
          overflow: "hidden", // Prevent scrolling at this level
          pt: 2,
          px: { xs: 2, md: 3 },
          pb: 0,
        }}
      >
        <Grid
          component={Stack}
          spacing={2}
          sx={{
            m: 0,
            width: "100%",
            flexGrow: 1,
            alignItems: "center",
            height: "100%",
            pt: 0,
            px: 0,
            pb: 0,
          }}
        >
          <Header />

          <Box sx={{ width: "100%", flexGrow: 1, overflow: "hidden" }}>
            <MainGrid />
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default Dashboard;
